import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "concent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_Step3 = _resolveComponent("Step3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "Close Account",
      backgroundColor: "#FFFFFF",
      fontColor: "#303133"
    }),
    ($setup.currentStep === 1)
      ? (_openBlock(), _createBlock(_component_Step1, {
          key: 0,
          onCurrentPage: $setup.currentPage
        }, null, 8, ["onCurrentPage"]))
      : _createCommentVNode("", true),
    ($setup.currentStep === 2)
      ? (_openBlock(), _createBlock(_component_Step2, {
          key: 1,
          onCurrentPage: $setup.currentPage
        }, null, 8, ["onCurrentPage"]))
      : _createCommentVNode("", true),
    ($setup.currentStep === 3)
      ? (_openBlock(), _createBlock(_component_Step3, {
          key: 2,
          onLiteRefresh: $setup.checkAccountCancellationLite,
          onKiliRefresh: $setup.checkAccountCancellationKili,
          cancellationInfo: $setup.cancellationInfo
        }, null, 8, ["onLiteRefresh", "onKiliRefresh", "cancellationInfo"]))
      : _createCommentVNode("", true)
  ]))
}